/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 *   IMPORTANT: This file is used by the internal build
 *   script `extract-intl`, and must use CommonJS module syntax
 *   You CANNOT use import/export in this file.
 */
const addLocaleData = require('react-intl').addLocaleData;
const enLocaleData = require('react-intl/locale-data/en');
const viLocaleData = require('react-intl/locale-data/vi');

import viTranslationMessages from './translations/vi';

addLocaleData(enLocaleData);
addLocaleData(viLocaleData);

export const DEFAULT_LOCALE = 'vi';

// prettier-ignore
export const appLocales = [
  'en',
  'vi',
];

export const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE ? formatTranslationMessages(DEFAULT_LOCALE, viTranslationMessages) : {};
  const flattenFormattedMessages = (formattedMessages, key) => {
    const formattedMessage =
      !messages[key] && locale !== DEFAULT_LOCALE ? defaultFormattedMessages[key] : messages[key];
    formattedMessages[key] = formattedMessage;
    return formattedMessages;
  };
  return Object.keys(messages).reduce(flattenFormattedMessages, {});
};

/**
 * Code-split i18n theo lang (giảm main.js ~171KB raw cho user VI).
 * - vi (default + fallback) load EAGER — luôn cần.
 * - en (+ en/locations, ~171KB) load DYNAMIC — chỉ user EN mới tải.
 *
 * `translationMessages` là object MUTABLE: vi có sẵn, en rỗng tới khi
 * ensureLocaleLoaded('en') fill. LanguageProvider/consumers đọc theo key lang
 * runtime — gọi ensureLocaleLoaded TRƯỚC khi render locale đó (app.tsx lúc start
 * nếu lang=en; LanguageProvider khi user đổi sang en).
 */
export const translationMessages: { [locale: string]: { [id: string]: string } } = {
  vi: formatTranslationMessages('vi', viTranslationMessages),
  en: {},
};

let enLoadPromise: Promise<void> | null = null;

export const ensureLocaleLoaded = (locale: string): Promise<void> => {
  if (locale !== 'en') return Promise.resolve();
  if (Object.keys(translationMessages.en).length > 0) return Promise.resolve();
  if (!enLoadPromise) {
    enLoadPromise = import(/* webpackChunkName: "i18n-en" */ './translations/en').then((mod) => {
      const enMessages = (mod as any).default || mod;
      translationMessages.en = formatTranslationMessages('en', enMessages);
    });
  }
  return enLoadPromise;
};
